module.exports = __webpack_public_path__ + "static/media/COS_IBSA.55044be7.png";